import { render, staticRenderFns } from "./TaskDetailWidget.vue?vue&type=template&id=4cf8ac12&scoped=true&"
import script from "./TaskDetailWidget.vue?vue&type=script&lang=js&"
export * from "./TaskDetailWidget.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailWidget.vue?vue&type=style&index=0&id=4cf8ac12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8ac12",
  null
  
)

export default component.exports